"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var momentizeValue = function momentizeValue(value, format, isUtc) {
  if (_lodash["default"].isNil(value) || value === '') {
    return null;
  }
  var date = null;
  if (/^[-]?\d+$/.test(value)) {
    date = _moment["default"].unix(value);
  } else if (_lodash["default"].isString(value) && !(value instanceof Date)) {
    date = (0, _moment["default"])(value, format || 'MM/DD/YYYY');
  } else {
    date = (0, _moment["default"])(value);
  }
  if (isUtc) {
    return date.utc();
  }
  return date;
};
var _default = momentizeValue;
exports["default"] = _default;